export default "/_next/static/images/d5d0e5516e85490952379814530c87cf.svg";